// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"6cde258d","1870":"23b86144","2587":"6cde258d"}[chunkId] + ".chunk.css";
};